import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 7.5rem;

  img {
    margin-bottom: 48px;
  }
`;

export const SentMessageTo = styled.p`
  color: #495156;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 1.2px;
  margin-bottom: 16px;
  height: 36px;

  span {
    font-weight: 700;
  }
`;

export const TermSentViaText = styled.p`
  color: #2aaeae;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 1.2px;
  height: 36px;
  margin-bottom: 32px;
`;

export const Button = styled.button`
  height: 45px;
  padding: 0 32px;
  margin-bottom: 32px;
`;

export const BeneficiaryNotReceivedText = styled.p`
  color: #495156;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 24px;

  span {
    font-weight: 700;
  }

  span.resend {
    color: #ff1783;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    text-decoration-line: underline;
    cursor: pointer;
  }
`;

export const ResendContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    color: #495156;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
  }

  span {
    color: #ff1783;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    text-decoration-line: underline;
    cursor: pointer;
  }

  p:first-child {
    margin-right: 48px;
  }
`;

export const ButtonResend = styled.button`
  display: flex;
  height: 45px;
  padding: 0 32px;
  justify-content: center;
  align-items: center;
  border-radius: 145px;
  background: #aafe48;
  color: #43474A;
  font-weight: 400;
  font-size: 18px;
  border: 0;
  letter-spacing: 0.9px;
`;
